import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/lang'
import mixin from '@/utils/mixin'

class GlobalDialog {
  constructor(component, configs) {
    this.instance = null
    this.init(component, configs)
  }
  init(component, configs) {
    Vue.mixin(mixin)
    const GlobalComponent = Vue.extend(component)
    const { instance } = this
    if (instance) {
      this.destroySelf()
    }
    const { propsData } = configs
    this.instance = new GlobalComponent({
      router,
      store,
      i18n,
      propsData: { ...(propsData || {}), source: 'append' },
      methods: {
        destroySelf: () => this.destroySelf(),
        removeDom: () => this.removeDom(),
        mountDom: () => this.mountDom()
      }
    }).$mount()
    this.mountDom()
  }
  destroySelf() {
    const { instance } = this
    if (instance) {
      console.log('start', this.instance)
      this.instance.$destroy()
      this.removeDom()
      console.log('destroy', this.instance)
      this.instance = null
      console.log('end', this.instance)
    }
  }
  mountDom() {
    const wrapper = document.getElementById('app')
    const element = this.instance.$el
    wrapper.appendChild(element)
  }
  removeDom() {
    const wrapper = document.getElementById('app')
    const element = this.instance.$el
    if (wrapper.contains(element)) {
      wrapper.removeChild(element)
    }
  }
}
export default GlobalDialog
